import messageResource from '../messageResource'
import SelectorPanelWithApplyButtonHelper from './selectorControls/at_selector_panel_with_apply_button_object'
import Ext from 'Ext'
import SelectorDropdownButton from './selectorControls/at_selector_dropdown_button'

export default function ReportLeaveTypesSelectorButton() {}

ReportLeaveTypesSelectorButton.prototype.init = function ( renderTo, leavesSelection, leavesData,
                                                           ptoFeatureEnabled, sickBalanceFeatureEnabled, changeCallback, withApplyButton )
{
    const leaveSelectorUtil = new LeaveTypesSelectorUtil().init(leavesData, ptoFeatureEnabled, sickBalanceFeatureEnabled, leavesSelection.leaveTypes);

    const ptoName = messageResource.getMessage("leaves_selector.group_label.pto_balance");
    const sdbName = messageResource.getMessage("leaves_selector.group_label.sick_days_balance");
    const bothName = ptoFeatureEnabled && sickBalanceFeatureEnabled ?
        messageResource.getMessage("leaves_selector.group_label.both") : ptoFeatureEnabled ? ptoName : sdbName;

    const leaveSelectorData = leaveSelectorUtil.getDataForSelector(
        {
            ptoLabel : messageResource.getMessage('leaves_selector.group_label.affects', [ptoName]),
            sickDaysLabel : messageResource.getMessage('leaves_selector.group_label.affects', [sdbName]),
            withoutBalancesLabel : messageResource.getMessage('leaves_selector.group_label.does_not_affect', [bothName])
        }
    );

    const leavesConfig = {
        data: leaveSelectorData,
        optionValue: leavesSelection.qualifier,
        showInactive: leaveSelectorUtil.isNeedToShowInactiveLeaves() || leavesSelection.showInactive,
        showResetButton: true,
        isMarkAllSelectedIsEmpty: false
    };

    const panelConstructor = AT.ReportLeavesSelectorPanel;
    leaveSelectorUtil.setSelectorTreeConstructorToPanel(panelConstructor);

    if ( withApplyButton )
        Ext.apply( leavesConfig, SelectorPanelWithApplyButtonHelper.getApplyButtonExtension( panelConstructor ) );
    const leavesSelector = new panelConstructor( leavesConfig );

    const self = this;
    leavesSelector.on("change", function() {
        self.leavesSelector.wasChanged = true;
    });

    this.leavesSelector = new SelectorDropdownButton({
                                                            additionalMenuCls: "leaveTypeSelector",
                                                            renderTo: renderTo,
                                                            labelCls: "hierarchySelectorButton",
                                                            minWidth: 457,
                                                            selectorPanel: leavesSelector
                                                        });

    this.leavesSelector.setMenuHideCallback(function(){
        if (changeCallback && self.leavesSelector.wasChanged) self.leavesSelector.wasChanged = false; changeCallback();
    });

    return this;
};

ReportLeaveTypesSelectorButton.prototype.getLeaveTypeSelection = function ()
{
    const leavesSelector = this.leavesSelector.selectorPanel;
    const leaveTypes = [];
    for ( let i = 0; i < leavesSelector.getSelection().length; ++i ) {
        leaveTypes.push(leavesSelector.getSelection()[i].id);
    }

    return  {
        leaveTypes: leaveTypes,
        qualifier: leavesSelector.getCurrentOptionValue(),
        showArchived: leavesSelector.getShowInactive()
    };
};

ReportLeaveTypesSelectorButton.prototype.resetLeavesSelectionFunction = function()
{
    this.leavesSelector.selectorPanel.resetState(true);
};

ReportLeaveTypesSelectorButton.prototype.setInitialValuesFromCurrent = function()
{
    this.leavesSelector.selectorPanel.setInitialValuesFromCurrent();
};

ReportLeaveTypesSelectorButton.prototype.isEmptySelection = function()
{
    return this.leavesSelector.selectorPanel.isEmptySelection();
};

ReportLeaveTypesSelectorButton.prototype.isStateChanged = function()
{
    return this.leavesSelector.selectorPanel.isStateChanged();
};


// WEBPACK FOOTER //
// ./web/js/controls/ReportLeaveTypesSelectorButton.js